export enum TransferRateType {
  Points = 'points_transfer_rate',
  Cash = 'cash_transfer_rate',
}

interface TransferRateGeneric<T extends TransferRateType> {
  id: string;
  type: T;
  denomination: number;
  targetDenomination: number;
  minimumTransfer: number;
  maximumTransfer: number;
  exchangeRate: number;
  loyaltyCurrencyId: string;
  targetMaximumTransfer: number;
  targetMinimumTransfer: number;
}

export type CashTransferRate = TransferRateGeneric<TransferRateType.Cash>;
export type PointsTransferRate = TransferRateGeneric<TransferRateType.Points>;

export type TransferRate = CashTransferRate | PointsTransferRate;
